import styled from '@emotion/styled';
import { useState } from 'react';
import FirstModal from './firstModal';
import SecondModal from './secondModal';

const BrandStory:React.FC<any> = () => {
  const [ firstShowModal, setFirstShowModal ] = useState(false);
  const [ secondShowModal, setSecondShowModal ] = useState(false);

  const handleFirstShowModal = () => {
    setFirstShowModal(true);
  }

  const firstCloseModal = () => {
    if (firstShowModal === true) return setFirstShowModal(false);
  };

  const handleSecondShowModal = () => {
    setSecondShowModal(true);
  }

  const secondCloseModal = () => {
    if (secondShowModal === true) return setSecondShowModal(false);
  };
  
  return (
    <Container>
      <Title>BRAND STORY</Title>
      <CardContainer>
        <Card
          onClick={handleFirstShowModal}
        >
          <CardImgWrapper>
            <Img src="/images/newLanding/home/brand1.png"/>
          </CardImgWrapper>
          <TextBox>
            <BoldText className="title">찍기만 한다고 남나요</BoldText>
            <BoldText className="body">[30초 스토리]</BoldText>
            <br/>
            <BoldText className="body">언제부터 사진의 가치가 떨어졌을까요?</BoldText>
          </TextBox>
        </Card>
        <Card
          onClick={handleSecondShowModal}
        >
          <CardImgWrapper>
            <Img src="/images/newLanding/home/brand2.png"/>
          </CardImgWrapper>
          <TextBox>
            <BoldText className="title">가족과 앨범을 보던 추억</BoldText>
            <BoldText className="body">[30초 스토리]</BoldText>
            <br/>
            <BoldText className="body">본가에는 엄마가 해준 앨범이 있습니다.</BoldText>
          </TextBox>
        </Card>
      </CardContainer>
      {firstShowModal && <FirstModal showModal={firstShowModal} closeModal={firstCloseModal}/>}
      {secondShowModal && <SecondModal showModal={secondShowModal} closeModal={secondCloseModal}/>}
    </Container>
  )
};

export default BrandStory;

const Container = styled.div`
  width: 100%;
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

const Title = styled.div`
  margin: 80px auto 60px;
  font-size: 26px;
  font-weight: normal;
`;

const CardContainer = styled.div`
  width: 90%;
  height: 300px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto 40px;
`;

const Card = styled.div`
  width: 47%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const CardImgWrapper = styled.div`
  width: 97%;
  height: 60%;
  margin-bottom: 10px;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`
const TextBox = styled.div`
  width: 100%;
  height: 40%;
  display: flex;
  flex-direction: column;
`;

const BoldText = styled.div`
  display: flex;
  text-align: start;
  
  &.title{
    margin-bottom: 3px;
    font-size: 16px;
  }

  &.body{
    font-size: 14px;
    font-weight: 500;
  }
` 